export default ({
  landingPage: { info, internalLinks, breadcrumbs, seoContent } = {}
} = {}) => ({ info, internalLinks, breadcrumbs, seoContent })
